import React from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={container}>
      <h1 style={{ fontSize: "60px", color: "#2bb673" }}>404</h1>
      <h2>Page Not Found</h2>
      <p>Oops! Jo page tum dhoond rahe ho wo exist nahi karta.</p>

      <button style={btn} onClick={() => navigate("/")}>
        Go to Home
      </button>
    </div>
  );
}

const container = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  background: "#f5f5f5",
};

const btn = {
  marginTop: "20px",
  padding: "10px 20px",
  border: "none",
  borderRadius: "5px",
  background: "#2bb673",
  color: "#fff",
  cursor: "pointer",
};

export default NotFound;